import { Button, Col, Form, Row, Space } from "antd";
import React, { useMemo } from "react";

import { SupportedControls, SingleOrderActions } from "../../molecules";

export const SingleOrderForm: React.FC<{
  controls: any;
  id: any;
  patch_url?: string;
}> = ({ controls, id, patch_url }) => {
  // Collect all child UUIDs from field-group controls
  const childUuids = useMemo(() => {
    const uuids = new Set<string>();
    controls.forEach((control: any) => {
      if (control.field_type === "field-group" && Array.isArray(control.children)) {
        control.children.forEach((uuid: string) => uuids.add(uuid));
      }
    });
    return uuids;
  }, [controls]);

  // Filter out controls that are children of a field-group
  const visibleControls = useMemo(() => {
    return controls.filter((control: any) => !childUuids.has(control.uuid));
  }, [controls, childUuids]);

  return (
    <Form layout="vertical">
      <Row gutter={16}>
        {[...visibleControls]
          .sort((a: any, b: any) => {
            return a.position - b.position;
          })
          .map((control: any) => {
            return (
              <Col span={control.displaying_size} key={control.uuid}>
                <SupportedControls control={control} allControls={controls} />
              </Col>
            );
          })}
      </Row>
      <SingleOrderActions id={id} patch_url={patch_url} />
    </Form>
  );
};
